import React, { Component } from 'react';
import axios from 'axios';
import './index.scss';

class ChatbotEmailForm extends Component {
  state = {
    emailValue: '',
    domainValue: '',
    pending: false,
    success: false,
    error: false,
    message: ''
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { domainValue, emailValue } = this.state;

    if (!this.validateDomain(domainValue) || !this.validateEmail(emailValue)) return;

    this.setState({ pending: true, error: false, success: false });

    axios
      .post('/api/submit-demo-request', {
        from: emailValue,
        domain: domainValue
      })
      .then(() => {
        this.setState({
          pending: false,
          success: true,
          message: 'Vielen Dank! Die Demo wird in Kürze eingerichtet.',
          domainValue: '',
          emailValue: ''
        });
      })
      .catch(() => {
        this.setState({
          pending: false,
          error: true,
          message: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.'
        });
      });
  };

  handleDomainChange = (e) => {
    this.setState({ domainValue: e.target.value });
  };

  handleEmailChange = (e) => {
    this.setState({ emailValue: e.target.value });
  };

  validateEmail = (email) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const valid = pattern.test(email);
    if (!valid) {
      this.setState({
        error: true,
        message: 'Bitte geben Sie eine gültige E-Mail Adresse ein.'
      });
    }
    return valid;
  };

  validateDomain = (domain) => {
    const pattern = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;
    const valid = pattern.test(domain);
    if (!valid) {
      this.setState({
        error: true,
        message: 'Bitte geben Sie eine gültige Domain ein.'
      });
    }
    return valid;
  };

  render() {
    const { domainValue, emailValue, pending, success, error, message } = this.state;

    return (
      <div className="chatbotdemo" id="chatbotdemo">
        <div className="chatbotdemo__container">
          <h2>Jetzt Demo anfordern</h2>
          <p>
            Einfach Ihre E-Mail-Adresse und Ihre Website angeben – wir analysieren Ihre Seite und senden Ihnen innerhalb von 24 Stunden an Werktagen ein JavaScript-Snippet zur Einbindung.
            <br />
            Die Demo läuft <strong>30 Tage oder bis zu 500 Anfragen</strong> – kostenlos und unverbindlich.
            <br />
            Setup-Gebühren fallen nur an, wenn Sie den Chatbot nach der Demo weiterhin nutzen möchten.
          </p>

          <form className="chatbotdemo__form" onSubmit={this.handleSubmit}>
            <input
              type="email"
              className="chatbotdemo__input"
              placeholder="Ihre E-Mail Adresse"
              value={emailValue}
              onChange={this.handleEmailChange}
            />
            <input
              type="text"
              className="chatbotdemo__input"
              placeholder="Ihre Website (z. B. beispiel.at)"
              value={domainValue}
              onChange={this.handleDomainChange}
            />
            <button type="submit" className="chatbotdemo__button" disabled={pending}>
              {pending ? 'Wird gesendet…' : 'Demo anfordern'}
            </button>
          </form>

          {message && (
            <div className={`chatbotdemo__status ${success ? 'success' : ''} ${error ? 'error' : ''}`}>
              {message}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ChatbotEmailForm;
